import React, { useEffect, useState,useCallback } from 'react'
import AppSidebar from '../../../components/AppSidebar';
import AppHeader from '../../../components/AppHeader';
import PageHeader from '../../../components/PageHeader';
import { ToastContainer, toast } from 'react-toastify';
import  FeedbackLinkService  from '../../../services/FeedbackLinkService';
import  Pagination  from '../../../components/Pagination';
import { FaRegCopy } from "react-icons/fa";
import UseDebounce from '../../../hooks/UseDebounce';
import { PageLimit } from '../../../utils/ConstantUtils';
import { DebounceDelay } from '../../../utils/ConstantUtils';
import Filters from '../../../components/Filters';

const ListFeedbackLinks = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const pageLimit = PageLimit || 20;
    const [itemsPerPage, setPageLimit] = useState(pageLimit);
    const offset = (currentPage - 1) * itemsPerPage;
    const [appliedFilters, setAppliedFilters] = useState({});
    const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);

    const fetchFeedbacks = useCallback(async () => {
        setLoading(true);
        try {
            const response = await FeedbackLinkService.getAll({
                page: currentPage,
                limit: itemsPerPage,
                search: debouncedSearchTerm,
                offset: offset,
                filters: appliedFilters,
            });
            if (response.status === 200) {
                setRows(response?.data?.data?.feedbackLinks);
                setTotalPages(response?.data?.data?.meta?.totalPages);
                setCurrentPage(response?.data?.data?.meta?.currentPage);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error(error);
        } finally {
            setLoading(false);
        }
    },[currentPage, itemsPerPage, debouncedSearchTerm, offset, appliedFilters]);

    useEffect(() => {
        fetchFeedbacks();
    }, [appliedFilters, fetchFeedbacks]);

    const handleCopyLink = async (link) => {
        if (!link) {
            toast.error("No link available to copy");
            return;
        }
        navigator.clipboard.writeText(link)
            .then(() => toast.success("Link copied to clipboard!"))
            .catch(() => toast.error("Failed to copy link"));
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (e) => {
        setCurrentPage(1);
        setPageLimit(e.target.value);
    };
    const filterFields = [
        { name: "name", placeholder: "Customer Name" },
        { name: "product", placeholder: "Product Name" },
        { name: "type", placeholder: "Type" },
        { name: "status", placeholder: "Status" },
    ];
    const handleApplyFilters = (filters) => {
        setAppliedFilters(filters);
        console.log("Applied Filters:", filters); 
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader title='Feedbacks' />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 ">
                            <PageHeader title="Feedbacks" className="btn btn-primary btn-sm" button_label="Add New" link_to="create" />
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="feedbackListPane" role="tabpanel" aria-labelledby="feedbackListTab">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <form>
                                                        <div className="input-group input-group-flush input-group-merge input-group-reverse">
                                                            <input
                                                                className="form-control list-search"
                                                                type="text"
                                                                placeholder="Search"
                                                                value={searchTerm}
                                                                onChange={handleSearchChange}
                                                            />
                                                            <span className="input-group-text">
                                                                <i className="fe fe-search" />
                                                            </span>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="col-auto me-n3">
                                                    <form>
                                                        <select
                                                            className="form-select form-select-sm form-control-flush"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value="20">20 per page</option>
                                                            <option value="40">40 per page</option>
                                                            <option value="60">60 per page</option>
                                                            <option value="100">100 Records</option>
                                                        </select>
                                                    </form>
                                                </div>
                                                <div className="col-auto">
                                                <Filters filterFields={filterFields} onApplyFilters={handleApplyFilters} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            {loading && (
                                                <div className="text-center">Loading...</div>
                                            )}
                                            <table className="table table-sm table-nowrap">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Customer Name</th>
                                                        <th scope="col">Product Name</th>
                                                        <th scope="col">Link</th>
                                                        <th scope="col">Status</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rows.length > 0 ? (
                                                        rows.map((row, index) => (
                                                            <tr key={row.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{row?.customer?.company || "N/A"}</td>
                                                                <td>{row?.product?.name || "N/A"}</td>
                                                                <td>{row?.link || "N/A"}</td>
                                                                <td>
                                                                    <span className={`badge bg-${row.status === 'active' ? 'success' : 'danger'}`}>{row.status}</span>
                                                                </td>
                                                                <td>
                                                                    <button className="btn btn-sm btn-primary btn-sm" title='Copy Link'  onClick={() => handleCopyLink(row.link)}><FaRegCopy /></button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center">No records found</td>
                                                        </tr>
                                                    )}

                                                </tbody>
                                            </table>
                                        </div>
                                            <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default ListFeedbackLinks